import { NgModule } from '@angular/core';
import { GetFromAEMPipe } from './get-from-aem/get-from-aem.pipe';

@NgModule({
  declarations: [GetFromAEMPipe],
  exports: [GetFromAEMPipe],
})
export class SharedPipesModule {}
